import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons-vue';

export const showNotificationSuccess = (
    message: string, 
    description?: string | null, 
    classType: 'notification--message' | 'notification--titleOnly' = 'notification--message'
): void  => {
    notification.open({
        message: message,
        description: (description) ? description : null,
        placement: 'top',
        icon: () => h(CheckCircleOutlined, { style: 'color: #000' }),
        class: (description) ? classType : 'notification--titleOnly',
    });
}

export const showNotificationError = (
    message: string, 
    description?: string | null, 
    classType: 'notification--message' | 'notification--titleOnly' = 'notification--message'
): void  => {
    notification.open({
        message: message,
        description: (description) ? description : null,
        placement: 'top',
        icon: () => h(CloseCircleOutlined, { style: 'color: #000' }),
        class: (description) ? classType : 'notification--titleOnly',
    });
}